var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "", id: "step12" } },
    [
      _c("StationMap", {
        attrs: {
          allStations: _vm.allStations,
          "hide-view-details": "",
          maxHeight: 600,
          zoom: 14,
          height: 300,
        },
      }),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { attrs: { dense: "", dark: "", color: "primary" } },
        [
          _c(
            "v-toolbar-title",
            [
              _c("v-icon", { attrs: { medium: "" } }, [_vm._v("place")]),
              _vm._v("\n      Location Details\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MonitoringFeatureDetails", {
        staticClass: "mb-2",
        attrs: { editForm: _vm.editForm },
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "pb-2", attrs: { xs12: "", lg6: "" } },
            _vm._l(_vm.leftCards, function (sourceType, index) {
              return _c(
                _vm.SOURCE_TYPE_COMPONENTS[sourceType],
                _vm._b(
                  { key: `sourceTypeComponent-${index}`, tag: "component" },
                  "component",
                  {
                    editForm: _vm.editForm,
                    wideForm: _vm.cardSetup.wideForm,
                    class: _vm.getMarginsClass(index, true),
                  },
                  false
                )
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", lg6: "" } },
            _vm._l(_vm.rightCards, function (sourceType, index) {
              return _c(
                _vm.SOURCE_TYPE_COMPONENTS[sourceType],
                _vm._b(
                  { key: `sourceTypeComponent-${index}`, tag: "component" },
                  "component",
                  {
                    editForm: _vm.editForm,
                    wideForm: _vm.cardSetup.wideForm,
                    class: _vm.getMarginsClass(index, false),
                  },
                  false
                )
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLastUnevenCard(_vm.sourceTypes.length - 1)
        ? _c(
            _vm.SOURCE_TYPE_COMPONENTS[
              _vm.sourceTypes[_vm.sourceTypes.length - 1]
            ],
            _vm._b(
              { tag: "component" },
              "component",
              { editForm: _vm.editForm, wideForm: _vm.cardSetup.wideForm },
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTenantAdmin
        ? _c(
            "v-card-actions",
            [
              !_vm.editForm
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "warning", large: "" },
                      on: {
                        click: function ($event) {
                          _vm.editForm = true
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("edit")]),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("Button.Edit_Station_Information")) +
                          "\n    "
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", large: "" },
                      on: {
                        click: function ($event) {
                          _vm.editForm = false
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("done")]),
                      _vm._v(
                        "\n      " + _vm._s(_vm.$t("Button.Done")) + "\n    "
                      ),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }